import { Typography } from 'antd';

const { Text } = Typography;

const NehrOptOut = () => (
  <div>
    <div className="rounded-2xl bg-white p-4">
      <Text className="text-sm">You have opted out of NEHR.</Text>
    </div>
  </div>
);

export default NehrOptOut;
